<template>
	<v-card v-if="item.firstName" outlined>
		<v-card-title> {{ item.firstName }} {{ item.lastName ? item.lastName : '' }} </v-card-title>
		<v-card-subtitle class="pb-0 text-left">
			rut: {{ item.rut ? item.rut : 'Sin rut' }}
		</v-card-subtitle>
		<v-subheader :class="globalBackground">Datos</v-subheader>
		<v-list dense class="text-left">
			<v-list-item v-if="item.email">
				<v-list-item-content>
					<v-list-item-title> Correo electronico: {{ item.email }} </v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item v-if="item.state">
				<v-list-item-content>
					<v-list-item-title> Estado: {{ item.state }} </v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item v-if="item.age">
				<v-list-item-content>
					<v-list-item-title> Edad: {{ item.age }} </v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item v-if="item.birthday">
				<v-list-item-content>
					<v-list-item-title> Cuampleaños: {{ item.birthday }} </v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item v-if="item.function">
				<v-list-item-content>
					<v-list-item-title> Funcion: {{ item.function }} </v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item v-if="item.cargo">
				<v-list-item-content>
					<v-list-item-title> Cargo: {{ item.cargo }} </v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item v-if="item.phone">
				<v-list-item-content>
					<v-list-item-title> Telefono: {{ item.phone }} </v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item v-if="item.region">
				<v-list-item-content>
					<v-list-item-title> region: {{ item.region }} </v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			<v-list-item v-if="item.comuna">
				<v-list-item-content>
					<v-list-item-title> comuna: {{ item.comuna }} </v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
		<v-list two-line dense>
			<v-subheader :class="globalBackground">Documentos disponibles</v-subheader>
			<v-list-item-group color="primary" style="max-height: 180px; overflow: auto;">
				<template
					v-if="item && item.documents.length && item.documents.some(el => el !== null)"
				>
					<template v-for="(req, i) in item.typeDocument">
						<template v-if="req !== null">
							<v-list-item
								v-if="item.documents[i]"
								:key="i"
								tile
								link
								target="_blank"
								:href="item.documents[i].url"
							>
								<v-list-item-avatar>
									<v-icon v-if="itsDue(item.documents[i].date)" color="warning">
										mdi-clock-alert-outline
									</v-icon>
									<v-icon v-else color="success">
										mdi-checkbox-marked-circle-outline
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content class="text-left">
									<v-list-item-title class="text-capitalize">
										{{ item.documents[i].type }}
									</v-list-item-title>
									<v-list-item-subtitle
										v-if="itsDue(item.documents[i].date)"
										style="font-size: 8pt;"
										class="warning--text"
									>
										Caducado el {{ item.documents[i].date }}
									</v-list-item-subtitle>
									<v-list-item-subtitle v-else style="font-size: 8pt;">
										Creado: {{ createAt(item.documents[i].id) }}
										{{
											item.documents[i].date &&
												`- Vence: ${item.documents[i].date}`
										}}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</template>
					</template>
				</template>
				<template v-else>
					<Empty msj="No hay documentos disponibles" />
				</template>
			</v-list-item-group>
		</v-list>
		<v-list two-line dense>
			<v-subheader :class="globalBackground">Documentos pendientes</v-subheader>
			<v-list-item-group color="primary" style="max-height: 180px; overflow: auto;">
				<template
					v-if="
						item &&
							item.typeDocument.length &&
							item.typeDocument.some((el, i) => el !== null && !item.documents[i])
					"
				>
					<template v-for="(req, i) in item.typeDocument">
						<template v-if="req !== null && !item.documents[i]">
							<v-list-item :key="i" tile>
								<v-list-item-avatar>
									<v-icon color="warning">
										mdi-file-question-outline
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="text-left text-capitalize">
										{{ req.type }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</template>
					</template>
				</template>
				<template v-else>
					<Empty msj="No hay documentos pendientes" />
				</template>
			</v-list-item-group>
		</v-list>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn outlined color="error" @click.stop="unLink">
				{{ item.isUser ? 'Desvincular' : 'Eliminar' }}
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import moment from 'moment';
import { mapActions, mapMutations } from 'vuex';
import Empty from '@/components/ui/DataEmpty';

export default {
	name: 'PersonCard',
	components: {
		Empty,
	},
	props: {
		item: {
			type: Object,
			default: () => {},
		},
		cleaning: {
			type: Function,
			required: true,
		},
		id: {
			type: String,
			default: '',
		},
	},
	data() {
		return {};
	},
	methods: {
		createAt(date) {
			if (moment(date).format('l') != 'Invalid date') return moment(date).format('l');
			else return 'Sin fechas';
		},
		itsDue(date) {
			return moment(date).isBefore(moment().format());
		},
		async unLink() {
			if (this.item.isUser) {
				confirm('Estas seguro de desvincular esta persona?') &&
					(await this.unlinkInvite(this.item._id));
				this.cleaning();
			} else {
				confirm('Estas seguro de eliminarlo?') && (await this.deletePerson(this.item._id));
				this.cleaning();
				this.getPersonsByUser(this.id);
			}
		},
		...mapActions({
			getPersonsByUser: 'Person/getPersonsByUser',
			deletePerson: 'Person/deletePerson',
			unlinkInvite: 'Person/unlinkInvite',
		}),
		...mapMutations({ snackbar: 'Snackbar/showMessage' }),
	},
};
</script>

<style lang="scss" scoped></style>
